import {
  paymentActions,
  amlCheckActions,
  investigationHistoryActions,
  complianceStatsActions,
  complianceCategoryStatsActions,
  complianceTransferActions,
  complianceAlertStatsActions,
  complianceAlertsActions,
  complianceCustomersActions,
  complianceAlertLevelsActions,
  complianceListsActions,
  alertRulesActions,
} from '../actions';

const verifiedPaymentActionList = [
  paymentActions.enterPromoCode.type,
  paymentActions.setPaymentLoading.type,
  paymentActions.createStripeInvoice.type,
  paymentActions.createCryptoInvoice.type,
];

const checkRelatedActions = [
  ...Object.values(amlCheckActions).map((action) => action.type),
  ...Object.values(investigationHistoryActions).map((action) => action.type),
];

const emailConfirmationActions = new Set([
  ...verifiedPaymentActionList,
  ...checkRelatedActions,
]);

const restrictedActionsIfUserIsBlocked = new Set(emailConfirmationActions);

const complianceStatsList = [
  complianceStatsActions.fetchCustomerStats.type,
  complianceCategoryStatsActions.fetchCategoryStats.type,
  complianceTransferActions.fetchTransferStats.type,
  complianceTransferActions.fetchTransfers.type,
  complianceAlertStatsActions.fetchAlertStats.type,
  complianceAlertStatsActions.fetchAlertList.type,
  complianceAlertsActions.listAlerts.type,
  complianceAlertsActions.updateStatus.type,
  complianceCustomersActions.listCustomers.type,
  complianceCustomersActions.updateCustomer.type,
  complianceAlertLevelsActions.listAlertLevels.type,
  complianceAlertLevelsActions.updateLevels.type,
  complianceAlertLevelsActions.resetTransactionAlertsCategories.type,
  complianceListsActions.fetchLists.type,
  alertRulesActions.listAlertRules.type,
  alertRulesActions.createAlertRule.type,
  alertRulesActions.updateAlertRule.type,
  alertRulesActions.deleteAlertRule.type,
  alertRulesActions.activateAlertRule.type,
  alertRulesActions.deactivateAlertRule.type,
];
const complianceTokenizedActions = new Set([...complianceStatsList]);

export {
  emailConfirmationActions,
  restrictedActionsIfUserIsBlocked,
  complianceTokenizedActions,
};
